import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { ICmsComponent, ICmsContent, NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { AbstractCmsBlockComponent } from '../../../../../cms/block/abstract-cms-block.component';

export interface IProductUspBlockDataContent extends NICmsContentComponent.IData {
    column: IUspComponentColumn[];
}

export interface IUspComponentColumn {
    image: string;
    title: string;
    text: string;
    url?: string;
}

@Component({
    selector: 'product-view-usp-block',
    templateUrl: './product-view-usp-block.component.html',
    styleUrl: './product-view-usp-block.component.scss',
    standalone: true,
    imports: [CommonModule, DfImageDirective, HrefComponent, ICmsClientModule, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<ProductViewUspBlockComponent>({
    id: 'usp-block',
    block: {
        url: 'usp-block'
    },
    onDemandOnly: true,
    name: 'usp-block',
    fields: [
        <NICmsContentField.IRepeaterField>{
            type: NICmsContentField.EFieldType.repeater,
            key: 'column',
            title: 'Column',
            itemName: 'Column',
            defaultSize: 1,
            maxSize: 4,
            fields: [
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.image,
                    key: 'image',
                    title: 'Column image',
                    required: true
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'title',
                    title: 'Column title',
                    required: true
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'text',
                    title: 'Text',
                    required: true
                },
                <NICmsContentField.IField>{
                    type: NICmsContentField.EFieldType.text,
                    key: 'url',
                    title: 'Url'
                }
            ]
        }
    ]
})
export class ProductViewUspBlockComponent extends AbstractCmsBlockComponent implements NICmsContentComponent.IComponent {
    @ICmsContent({
        type: 'blockContent'
    })
    override content!: IProductUspBlockDataContent;
}
